module.exports = __webpack_public_path__ + "img/box-packaging-0@1x-min.6cb8c5bb.png";